export default [
  {
    title: "Order",
    customIcon: "CommonSVG",
    children: [
      {
        title: "Order List",
        route: "custom-module",
        path: "/custom-module/order",
      },
    ],
  },
];
